// export const APP_URL = "http://192.168.2.143:8000/api/v2";
// export const APP_URL = "http://api.resqcore.d/api/v2";

// export const APP_URL = "http://test.resqcore.kz:8000/api/v2";
export const APP_URL = "https://api.resqcore.kz/api/v2";
// export const APP_URL = "http://api.resqcore.d/api/v2";

// export const APP_URL = "https://sm.resqcore.kz/api/vƒ2";
// const envUrl = (process.env.REACT_APP_API_URL || '').replace(/\/+$/, '');
//
// if (process.env.NODE_ENV === 'production' && !envUrl) {
//     throw new Error('REACT_APP_API_URL must be provided at build time');
// }
//
// export const APP_URL = envUrl || 'http://api.resqcore.d/api/v2';


// export const APP_URL = "https://sm.resqcore.kz/api/v2";
// const envUrl = (process.env.REACT_APP_API_URL || '').replace(/\/+$/, '');
//
// if (process.env.NODE_ENV === 'production' && !envUrl) {
//     throw new Error('REACT_APP_API_URL must be provided at build time');
// }
//
// export const APP_URL = envUrl || 'http://api.resqcore.d/api/v2';

